import { Spinner } from "@phosphor-icons/react";
import ImageRenderer from "./ImageRenderer";
import PDFRenderer from "./PDFRenderer";

type DocumentPreviewProps = {
	signedUrl: string;
	isPdf?: boolean;
	alt?: string;
	onPreviewClick?: (url: string, isPdf: boolean) => void;
	isLoading?: boolean;
	onImageHover?: () => void;
};

const DocumentPreview = ({
	signedUrl,
	isPdf,
	alt = "Uploaded document",
	onPreviewClick,
	isLoading = false,
	onImageHover
}: DocumentPreviewProps) => {
	const containerClass = "flex h-full w-full items-center justify-center";

	if (isLoading) {
		return (
			<div className={containerClass}>
				<Spinner className="text-indigo-500" size={24} />
			</div>
		);
	}

	if (isPdf) {
		return (
			<div className={containerClass}>
				<PDFRenderer signedUrl={signedUrl} onPreviewClick={onPreviewClick} />
			</div>
		);
	}

	return (
		<div className={containerClass}>
			<ImageRenderer src={signedUrl} alt={alt} onHover={onImageHover} />
		</div>
	);
};

export default DocumentPreview;

